import { ReactElement } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import BreakoutAuthPage from "./BreakoutAuthPage/BreakoutAuthPage";
import { REDIRECT_AUTH_STATE } from "shared/localStorage/keys";

type RequestAuthPageProps = {
  authProvider: string;
};

const RequestAuthPage = ({
  authProvider,
}: RequestAuthPageProps): ReactElement => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const useBreakoutFlow = searchParams.get("breakout") === "true";

  const redirectAuthState = {
    redirectUri: `${location.pathname}${location.search}`,
    authProvider,
  };

  localStorage.setItem(REDIRECT_AUTH_STATE, JSON.stringify(redirectAuthState));

  return useBreakoutFlow ? (
    <BreakoutAuthPage authProvider={authProvider} />
  ) : (
    <Navigate to={"/redirect-authentication"} />
  );
};

export default RequestAuthPage;
